import { render, staticRenderFns } from "./BaiduPanBlock.vue?vue&type=template&id=6b32a3fc"
import script from "./BaiduPanBlock.vue?vue&type=script&lang=js"
export * from "./BaiduPanBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports